import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María G.',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Carlos R.',
  city: 'CDMX',
  country: 'México'
}, {
  name: 'Ana L.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Sofía N.',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Juan M.',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Laura V.',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Patricia S.',
  city: 'La Paz',
  country: 'Bolivia'
}, {
  name: 'Daniela P.',
  city: 'Santiago',
  country: 'Chile'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    const initialTimeout = setTimeout(showPopup, 4000);
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-261">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-slate-800 rounded-lg shadow-xl p-4 max-w-xs z-40 border-l-4 border-emerald-500 flex items-start gap-3" data-id="element-262">
          <div className="bg-emerald-500/20 p-2 rounded-full shrink-0" data-id="element-263">
            <CheckCircle2 className="w-5 h-5 text-emerald-400" data-id="element-264" />
          </div>
          <div data-id="element-265">
            <p className="text-sm font-bold text-white" data-id="element-266">
              {currentPurchase.name} de {currentPurchase.city},{' '}
              {currentPurchase.country}
            </p>
            <p className="text-xs text-slate-300 mt-1" data-id="element-267">
              acaba de comprar el{' '}
              <span className="font-semibold text-emerald-400" data-id="element-268">
                MegaPack Informática
              </span>
            </p>
            <p className="text-[10px] text-slate-500 mt-1" data-id="element-269">
              Hace unos segundos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}